<template>
  <div class="cell text-left margin-top">
    <div class="grid-x">
      <div class="cell small-12 space-1">
        <p v-for="(content, index) in $t(`service.${uid}.content`)" :key="index">{{ content }}</p>
        <hr>
        <carousel class="carousel do-centering-object" v-if="slide !== undefined" :perPage="1" :autoplay="true">
          <slide v-for="(picture, index) in slide" :key="index">
            <img :src="picture" alt="">
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'ServiceCard',
  props: ['uid', 'slide'],
  components: {Carousel, Slide}
}
</script>

<style lang="scss" scoped>
p {
  text-indent: 2em;
}
.carousel {
  max-width: 500px;
  width: 100%;
}
</style>

